{
  "ACTIVE": "ativo",
  "INACTIVE": "inativo",
  "ACCESS": "acessar",
  "MANAGER_RESELLER": "gerente",
  "COMMERCIAL_RESELLER": "Comercial",
  "FINANCIAL_RESELLER": "financeiro",
  "FINANCIAL_ADMINISTRATOR_RESELLER": "financeiro administrador",
  "MASTER_RESELLER": "administrador",
  "HEADQUARTER": "matriz",
  "COMPANY_BRANCH": "filial",
  "FAKE_LINK": "falso link",
  "LGPD": {
    "LABEL": "Privacidade, dados pessoais e uso da plataforma",
    "MESSAGE": "Sua privacidade é importante para nós e garantimos que suas informações serão tratadas de acordo com a nossa política de privacidade. Permito que meu conteúdo seja analisado pela Scansource para fim de aprimoramento e desenvolvimento de produtos.",
    "LINK_TEXT": "Configurações de privacidade",
    "FOOTER": "Caso você tenha alguma dúvida ou precisar de ajuda com o processo de cadastro, sinta-se à vontade para entrar em contato.",
    "REQUIRED_MESSAGE": "você precisa aceitar os termos",
    "TERMS_OF_USE": "Termos de uso da plataforma",
    "TERMS_OS_USE_LINK": "https://scansource.com.br/wp-content/uploads/2024/09/Termo_de_Uso_Plataforma_My_ScanSource_v.09.09.2024-1.pdf"
  },
  "BUTTON": {
    "ABOUT": "sobre",
    "BACK": "voltar",
    "GO": "ir",
    "HOME": "início",
    "TOGGLE_DARK": "alternar modo escuro",
    "TOGGLE_LANGS": "mudar de idioma",
    "ACCESS_MY_SCANSOURCE": "Acessar MyScanSource",
    "REQUEST_QUOTE": "Solicitar cotação",
    "NEW_USER": "Adicionar usuário",
    "ACCESS": {
      "MY_SCANSOURCE": "acessar o MyScanSource"
    }
  },
  "MEGA_MENU": {
    "OPTIONS": {
      "BUSINESS_INFO": "institucional",
      "CLIENT_SUCCESS": "pós vendas",
      "SOLUTIONS": "soluções"
    },
    "DESCRIPTION": {
      "BUSINESS_INFO": {
        "SUBTITLE": "conheça a empresa"
      },
      "CLIENT_SUCCESS": {
        "SUBTITLE": "sucesso do cliente"
      },
      "SOLUTIONS": {
        "SUBTITLE": "soluções para o seu negócio",
        "DESCRIPTIVE_TEXT": "a scansource tem soluções específicas para cada tipo de negócio. conheça nossas soluções e veja como podemos ajudar a sua empresa a crescer."
      }
    }
  },
  "CLIENTS": {
    "LABEL": "administrar clientes",
    "BUTTON": {
      "ADD": "adicionar cliente"
    },
    "TABLE": {
      "TITLE": "usuários cadastrados",
      "HEADERS": {
        "NAME": "nome",
        "EMAIL": "email",
        "USER_TYPE": "perfil",
        "CREATED_AT": "criação",
        "STATUS": "status",
        "ACTIONS": "ações"
      }
    },
    "ADD": {
      "LABEL": "usuários",
      "CARD_TITLE": "cadastro de usuário administrador",
      "FORM": {
        "FIRST_NAME": "nome",
        "PERSONAL_EMAIL": "email",
        "EMAIL": "email",
        "PASSWORD": "senha",
        "CONFIRM_PASSWORD": "confirmar senha",
        "PHONE_NUMBER": "telefone",
        "COMPANY_PHONE": "telefone",
        "CPF": "CPF",
        "LAST_NAME": "sobrenome",
        "COMPANY_NAME": "nome da empresa",
        "TAX_ID": "CNPJ",
        "SUBMIT": "cadastrar",
        "PROFILE": "Perfil"
      },
      "ERROR_MESSAGE": {
        "MULTIPLE": "Os {field} {name} precisam de atenção",
        "SINGLE": "O {field} {name} precisa de atenção"
      }
    }
  },
  "USERS": {
    "PROFILE_OPTIONS": {
      "MANAGER": "Gerenciador",
      "ADMIN": "Administrador",
      "COMMERCIAL": "Comercial",
      "FINANCIAL": "Financeiro",
      "FINANCIAL_ADMINISTRATOR": "Financeiro Administrador"
    },
    "INVITE": {
      "ALERTS": {
        "INVALID_SUBMIT": "Verifique os campos indicados",
        "SUCCESS": "Convite enviado com sucesso!"
      },
      "CARD_TITLE": "Cadastro de usuário",
      "FORM": {
        "EMAIL": "e-mail",
        "PROFILE": "perfil"
      },
      "TITLE": "adicionar usuário",
      "ERROR_1": "Este e-mail já consta neste Grupo Econômico com o perfil de acesso ",
      "ERROR_2": "Caso ele continue com o mesmo perfil já cadastrado, não é necessária nenhuma ação.",
      "ERROR_3": "Este usuário já será vinculado a este CNPJ.",
      "ERROR_4": "Caso seja necessário alterar o perfil de acesso, ",
      "ERROR_5": "Não é possível realizar uma nova solicitação para a empresa ",
      "ERROR_6": ", pois já existe uma solicitação em aberto.",
      "ISNOTPOSSIBLETOMAKENEWREQUESTFORTHECOMPANYDOCUMENTBECAUSEASTHEREISALREADYOPENREQUEST_1": "Não é possível realizar uma nova solicitação para a empresa ",
      "ISNOTPOSSIBLETOMAKENEWREQUESTFORTHECOMPANYDOCUMENTBECAUSEASTHEREISALREADYOPENREQUEST_2": ", pois já existe uma solicitação em aberto"
    },
    "STATUS_OPTIONS": {
      "ACTIVE": "Ativo",
      "INACTIVE": "Inativo"
    },
    "LIST": {
      "TABLE": {
        "HEADERS": {
          "NAME": "Nome",
          "EMAIL": "E-mail",
          "PROFILE": "Perfil",
          "CREATED_AT": "Criação",
          "STATUS": "Status",
          "ACTIONS": "Ações"
        }
      },
      "TABLE_UPDATED": "A listagem de usuários foi atualizada"
    },
    "REGISTER": {
      "LABEL": {
        "FIRST_NAME": "Nome:",
        "LAST_NAME": "Sobrenome:",
        "DOCUMENT": "CPF:",
        "EMAIL": "Email:",
        "PHONE_NUMBER": "Telefone:",
        "COMPANY_NAME": "Nome da Empresa:",
        "COMPANY_PHONE": "Telefone da Empresa:",
        "BIRTH_DATE": "Data de nascimento"
      },
      "BUTTON": {
        "SUBMIT": "Cadastrar"
      },
      "SUCCESS": {
        "TITLE": "Sucesso!",
        "MESSAGE": "Seu usuário foi cadastrado no nosso sistema!"
      },
      "CARD_TITLE": "Cadastro de usuário"
    },
    "UPDATE": {
      "LABEL": {
        "FIRST_NAME": "Nome:",
        "LAST_NAME": "Sobrenome:",
        "DOCUMENT": "CPF:",
        "EMAIL": "Email:",
        "PHONE_NUMBER": "Telefone:",
        "PROFILE_TYPE": "Perfil:",
        "BUTTON": "Salvar",
        "BIRTH_DATE": "Data de nascimento:"
      },
      "SUCCESS": {
        "MESSAGE": "Usuário editado com sucesso",
        "TITLE": ""
      },
      "ERROR": {
        "MESSAGE": "Problema ao editar usuário",
        "LEGAL_AGE": "Por motivos de política de privacidade, não podemos efetuar um cadastro de menor de 18 anos."
      }
    },
    "LABEL": "Administrar usuários",
    "NAVBAR_OPTIONS": {
      "TEXT": "Mantenha os cadstros atualizados"
    },
    "LABEL_LOWER": "administrar usuários",
    "BUTTON": {
      "ADD": "adicionar usuário"
    },
    "TABLE": {
      "TITLE": "usuários cadastrados",
      "HEADERS": {
        "FIRST_NAME": "nome",
        "EMAIL": "email",
        "PROFILE_TYPE": "perfil",
        "CREATED": "criação",
        "STATUS": "status",
        "ACTIONS": "ações",
        "NAME": "nome"
      },
      "SUMMARY": "lista de usuários registrados"
    },
    "_ADD": {
      "FORM": {
        "NAME": "nome",
        "SURNAME": "sobrenome",
        "CPF": "CPF",
        "EMAIL": "e-mail",
        "PHONE": "telefone"
      }
    },
    "ADD": {
      "LABEL": "usuários",
      "CARD_TITLE": "cadastro de usuário administrador",
      "FORM": {
        "name": "nome",
        "personalEmail": "email",
        "email": "email",
        "password": "senha",
        "confirmPassword": "confirmar senha",
        "phoneNumber": "telefone",
        "companyPhone": "telefone",
        "cpf": "CPF",
        "lastName": "sobrenome",
        "companyName": "nome da empresa",
        "taxId": "CNPJ",
        "submit": "cadastrar",
        "errorMessage": {
          "multiple": "Verifique os campos comentados abaixo.",
          "single": "Verifique o campo comentado abaixo."
        },
        "profile": "perfil"
      },
      "SUCCESS": {
        "message": "fique atento ao seu e-mail para cadastrar sua senha!"
      },
      "NO_DATA_TEXT": "Infelizmente este convite para criação de usuário já foi utilizado. Não é possível seguir com novo cadastro. Contate o administrador da sua Revenda no MyScanSource."
    },
    "FORM": {
      "FIRST_NAME": "Nome",
      "LAST_NAME": "Sobrenome",
      "DOCUMENT": "CPF",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Telefone",
      "PROFILE_TYPE": "Perfil",
      "PROFILE_TYPE_PLACEHOLDER": "Selecione um dos perfís",
      "STATUS": "Ativo/Inativo",
      "EDIT": {
        "SUBMIT": "salvar",
        "UPDATE_PASSWORD": "atualizar senha"
      }
    },
    "FORMS": {
      "ERRORS": {
        "SUBMIT": {
          "NOT_FOUND": "usuário não encontrado"
        }
      }
    },
    "EDIT": {
      "TITLE": "atualizar informações"
    }
  },
  "WORDS": {
    "FIELD": "campo",
    "FIELDS": "campos",
    "USER": "usuário",
    "CLICK_HERE": "clique aqui"
  },
  "FORMS": {
    "ERRORS": {
      "INVALID_SUBMIT": "Por favor, verifique a relação abaixo e tente novamente.",
      "SUBMIT": {
        "TITLE": "algo está errado...",
        "MESSAGE": "Houve um erro ao submeter o formulário"
      }
    },
    "SUCCESS": {
      "SUBMIT": "dados enviados com sucesso!"
    },
    "ERROR": {
      "SUBMIT": {
        "MESSAGE": "Veja os campos destacados ou comentados em vermelho no formulário",
        "TITLE": "verifique campos obrigatórios ou incorretos"
      }
    }
  },
  "DASHBOARD": {
    "BANNER": {
      "TITLE": "Acesso rápido",
      "SUBTITLE": "Tudo o que você precisa a um clique de distância!"
    },
    "LABEL": {
      "ACTION": {
        "ECONOMIC_GROUP": "Selecionar Empresa"
      }
    },
    "CUSTOMER_SERVICE": {
      "TITLE": "atendimento",
      "FIRST_PARAGRAPH": "Responsável pelo atendimento",
      "SECOND_PARAGRAPH": "Entre em contato pelo nosso Whatsapp",
      "THIRD_PARAGRAPH": "Se preferir acesse a página de atendimento e saiba mais informações"
    },
    "ALERTS": {
      "ECONOMIC_GROUP_APPLIED": "Empresa selecionada {0}"
    },
    "ECONOMIC_GROUP": {
      "SUCCESS_SUMMARY": "Revenda alternada!",
      "SUCCESS_DETAIL": "Você agora verá os dados para a revenda {0}.",
      "FAILURE_DETAIL": "A revenda que você escolheu já está selecionada ou, pode não estar mais vinculada ao grupo econômico.",
      "FAILURE_SUMMARY": "A revenda não alterada!"
    },
    "LAST_ORDER_DETAILS_LINK": "Detalhes da Compra",
    "LAST_ORDER_TITLE": "Última Compra",
    "LAST_ORDER_AMOUNT_INVOICES": "Notas Fiscais"
  },
  "NEXT_STEPS": {
    "BANNER": {
      "TITLE": "Obrigado por escolher a MyScanSource",
      "SUBTITLE": "O cadastro é rápido e fácil. Você fará parte de nossa comunidade exclusiva."
    },
    "MESSAGE": "Será enviado um e-mail para este novo usuário se cadastrar e definir a senha. Caso este e-mail não tenha chegado em poucos minutos na caixa de entrada, por gentileza, peça para que o usuário em questão verifique a caixa de Spam.",
    "MESSAGE_FIRST_PARAGRAPH": "Será enviado um e-mail para este novo usuário se cadastrar e definir a senha.",
    "MESSAGE_SECOND_PARAGRAPH": "Caso este e-mail não tenha chegado em poucos minutos na caixa de entrada,",
    "MESSAGE_THIRD_PARAGRAPH": "por gentileza peça para que o usuário em questão verifique a caixa de Spam.",
    "NO_MAIL": {
      "TITLE": "O e-mail não foi recebido?",
      "MESSAGE": "e entre em contato pelo nosso formulário de ajuda."
    },
    "COMPLETE_CONFIRM": {
      "FIRST_TEXT": "Você receberá um e-mail para definição da sua senha.",
      "SECOND_TEXT": "Caso não tenha recebido em poucos minutos o e-mail em sua caixa de entrada,",
      "THIRD_TEXT": "por gentileza verifique a caixa de Spam.",
      "NO_EMAIL": "Não recebeu o e-mail?",
      "FOUTH_TEXT": "e entre em contato pelo nosso formulário de ajuda."
    }
  },
  "SENTENCES": {
    "CLICK_HERE": "clique aqui "
  },
  "HOME": {
    "ALERT": {
      "ACCESS_MY_SCANSOURCE": {
        "OFFLINE": {
          "TITLE": "Faça o login para acessar o MyScanSource."
        }
      }
    }
  },
  "NEED_LOGIN": {
    "TITLE": "É necessário estar autenticado para acessar.",
    "MESSAGE": "Clique no botão de login e autentique-se"
  },
  "RANSOM_REQUEST": {
    "RANSOM_REQUEST": "Solicitação de Resgate",
    "FILTER_OPTIONS": {
      "TIP": {
        "FILTERED_FIELD": "Solicitação de Resgate",
        "GENERIC_TERM": "Preencha com o dado escolhido a esquerda",
        "DUE_DATE": "Selecione o intervalo de Data da Solicitação de Resgate",
        "STATUS": "Status da solicitação de resgate",
        "VALUE": "Valor (R$)",
        "SEARCH": "Buscar",
        "CLEAR": "Limpar"
      },
      "PLACEHOLDER": {
        "FILTERED_FIELD": "Consultar por",
        "EMPTY": "Selecione uma opção a esquerda",
        "DUE_PERIOD": "Data de Solicitação de Resgate",
        "STATUS": "Status da solicitação de resgate",
        "VALUE": "Valor (R$)",
        "ID": "Escreva o número da solicitação de resgate"
      }
    },
    "FORM": {
      "TITLES": {
        "REQUEST_REDEMPTION": "Solicitar Resgate",
        "SECTION_1": "1 - Digite o valor que deseja resgatar:",
        "SECTION_2": "2 - Realize o upload da nota fiscal.",
        "SECTION_3": "3 - Informe o tipo de operação",
        "SECTION_4": "4 - Insira uma descrição",
        "REDEMPTION_VALUE": "Valor do resgate",
        "REDEMPTION_VALUE_INVALID": "O valor informado é maior do que o Saldo Disponível.",
        "VALUE_AVAIABLE": "Saldo disponível para resgate",
        "SCANSOURCE_DATA": "Veja aqui os dados do tomador para para emissão da nota fiscal.",
        "INVOICE_NUMBER": "Nro Nota Fiscal",
        "INVOICE_SERIE": "Série",
        "INVOICE_EMISSION_DATE": "Data da emissão",
        "CHOOSE_FILE": "Escolher arquivo",
        "NO_FILE": "Nenhum arquivo selecionado.",
        "BANK_DEPOSIT": "Depósito Bancário",
        "ACCOUNTS_MEETING": "Encontro de contas",
        "CANCEL": "Cancelar",
        "AVAILABLE_BALANCE": "Saldo Disponível"
      },
      "TOOLTIPS": {
        "VALUE": "Informe o valor do saldo a resgatar",
        "FILE": "Anexar a Nota fiscal em formato PDF",
        "QUESTION": "Saldo de créditos da conta corrente disponível para resgate",
        "OPERATION_TYPE": "Selecione a forma de recebimento",
        "DESCRIPTION": "Informe neste espaço uma observação ou os dados das Notas fiscais e parcelas a compensar (sujeito a análise para liberação)"
      },
      "MESSAGES": {
        "SUCCESS": "Solicitação de resgate enviada com sucesso!",
        "ERROR": "Erro ao enviar a solicitação de resgate",
        "INVALID_VALUE": "Valor inválido",
        "INVALID_FILE": "Arquivo inválido",
        "INVALID_OPERATION_TYPE": "Tipo de operação inválido",
        "INVALID_DESCRIPTION": "Descrição inválida"
      }
    }
  },
  "ECONOMIC_GROUP_COMPANY_LIST": {
    "SUMMARY": "lista de empresas do grupo econômico",
    "HEADER": {
      "NAME": "nome",
      "CNPJ": "CNPJ",
      "COMPANY_TYPE": "tipo"
    },
    "TITLE": "Empresas vinculadas",
    "COLUMNS": {
      "TYPE": "tipo",
      "CNPJ": "CNPJ",
      "NAME": "nome"
    }
  },
  "CHANGE_PASSWORD": "mudar senha",
  "ERRORS": {
    "SUBMIT": {
      "_422": "dados inconsistentes, recarregue a página e tente novamente"
    },
    "USERS": {
      "UPDATE": {
        "PROFILE_T_YPE": "Erro do tipo de usuário selecionado"
      }
    }
  },
  "ORDERS": {
    "LABEL": "todas as compras",
    "NUMBER": "#",
    "CREATED": "Data",
    "CLIENT_NAME": "Cliente",
    "INVOICE": "NF",
    "BILL": "Boleto",
    "DETAILS_ORDERS": {
      "TITLE": "detalhes da compra",
      "RESELLER_NAME": "Revenda/Intermediador",
      "FINAL_CUSTOMER_NAME": "Cliente final",
      "ORDER_NUMBER": "N.º da Compra",
      "PURCHASE_ORDER_NUMBER": "N.º de ordem de compra",
      "PROPOSAL_NUMBER": "N.º da proposta",
      "PAYMENT_METHOD": "Forma de pagamento",
      "STATUS_BY_INVOICE": "Status por nota fiscal",
      "INVOICE": "Nota fiscal",
      "TOTAL_BY_INVOICES": "Valor total das Notas Fiscais",
      "NET_COMMISSION": "Comissão líquida",
      "SHIPPING_RATE": "Taxa frete",
      "SHIPPING_COMMISSION": "Comissão frete",
      "DETAILS_BY_INVOICE": {
        "TITLE": "Detalhes do item por nota fiscal",
        "SUBTITLE": "Detalhes referentes a nota fiscal",
        "INVOICED_ITEM": "Itens faturados",
        "ITEMS": "Itens",
        "TAXES": "Taxas",
        "DETAILS_BY_TAXES": {
          "CONFINS_PERCENT": "COFINS %",
          "CONFINS_VALUE": "COFINS",
          "ICMS_PERCENT": "ICMS %",
          "ICMS": "ICMS",
          "IPI_PERCENT": "IPI %",
          "IPI_VALUE": "IPI",
          "ISS_PERCENT": "ISS %",
          "ISS_VALUE": "ISS",
          "PIS_PERCENT": "PIS %",
          "PIS_VALUE": "PIS"
        },
        "EXTRACT": "Extrato",
        "STATUS": "Situação",
        "CHART_FILE": "Valores e comissões",
        "INVOICED_TABLE": {
          "PRODUCT": "Prod.",
          "AMOUNT": "Qtd.",
          "CUSTOMER_BILLING": "Fat. cliente",
          "RESELLER_BILLING": "Fat. revenda",
          "TOOLTIPS": {
            "CUSTOMER_BILLING": "Valor unitário da NF sem taxas/impostos * Quantidade de itens",
            "RESELLER_BILLING": "Valor de margem para revenda * Quantidade de itens"
          }
        },
        "UNBILLED_ITEMS": "Itens não faturados",
        "UNBILLED_TABLE": {
          "ITEMS": "Itens",
          "DESCRIPTION": "Descrição",
          "AMOUNT": "Qtd."
        }
      },
      "STATEMENT": {
        "INVOICE_DETAILS": "Detalhes referente a nota fiscal"
      }
    },
    "DETAILS_TOOPTIP": "Ir para detalhes da compra",
    "STATUS": {
      "STATUS": "Status",
      "ALL": "Todos",
      "PROCESSING": "Processando",
      "PROCESSED": "Processado",
      "INVOICED": "Faturado",
      "PARTIALLY_INVOICED": "Parcialmente Faturado",
      "SHIPPED": "Enviado",
      "PARTIALLY_SHIPPED": "Parcialmente Enviado",
      "DELIVERED": "Entregue",
      "PARTIALLY_DELIVERED": "Parcialmente Entregue",
      "CANCELED": "Cancelado",
      "PARTIALLY_CANCELED": "Parcialmente Cancelado",
      "DELAYED": "Atrasado",
      "PARTIALLY_DELAYED": "Parcialmente Atrasado",
      "PAID": "Pago",
      "PARTIALLY_PAID": "Parcialmente Pago"
    },
    "PRODUCT_TYPE": {
      "ALL": "Todos",
      "HARDWARE": "Hardware",
      "SOFTWARE": "Software",
      "SERVICE_CLOUD": "Serviço e Cloud",
      "SOFTWARE_AND_SERVICE": "Software e Serviço",
      "CLOUD_SERVICE": "Serviço Cloud"
    },
    "TABLE": {
      "HEADERS": {
        "NUMBER": "#",
        "CREATED": "Data",
        "CLIENT": "Cliente",
        "STATUS": "Situação",
        "INVOICE": "NF",
        "BILL": "Boleto",
        "DETAILS": "Detalhes"
      },
      "FILTERS": {
        "GENERAL": "N.º do documento",
        "DATE": "Data de criação",
        "STATUS": "Situação"
      }
    },
    "FILTER_OPTIONS": {
      "ORDER_NUMBER": "Nº Compra",
      "FINAL_CUSTOMER_DOCUMENT": "CPF/CNPJ do Cliente Final",
      "FINAL_CUSTOMER_NAME": "Nome do Cliente Final",
      "RESELLER_DOCUMENT": "CNPJ do Revendedor",
      "PLACEHOLDER": {
        "ORDER_NUMBER": "Nº Compra",
        "FINAL_CUSTOMER_DOCUMENT": "Escreva o C.N.P.J. do cliente",
        "FINAL_CUSTOMER_NAME": "Nome do Cliente",
        "RESELLER_DOCUMENT": "CNPJ do Revendedor",
        "FILTERED_FIELD": "Consultar por",
        "EMPTY": "Selecione uma opção a esquerda"
      },
      "TIP": {
        "FILTERED_FIELD": "N° da compra, CPF/CNPJ ou Nome do cliente final",
        "GENERIC_TERM": "Preencha com o dado escolhido a esquerda"
      }
    },
    "FILTER_STATUS": {
      "PLACEHOLDER": "Status",
      "TIP": "Selecione o status que deseja encontrar"
    },
    "FILTER_PRODUCT_TYPE": {
      "PLACEHOLDER": "Tipo do Produto",
      "TIP": "Selecione o tipo que deseja encontrar"
    },
    "FILTER_DATE": {
      "PLACEHOLDER": "Período da compra",
      "TIP": "Selecione o período que deseja encontrar"
    },
    "LIST": {
      "TABLE": {
        "HEADERS": {
          "NUMBER": "N.º da compra",
          "DATE": "Data",
          "FINAL_CLIENT_DOCUMENT": "CPF/CNPJ Cliente Final",
          "FINAL_CLIENT_NAME": "Cliente Final",
          "STATUS": "Situação"
        },
        "TOOLTIPS": {
          "NUMBER_SERVICE": "Número do pedido",
          "NUMBER_CLOUD": "Ordem de faturamento"
        }
      },
      "TABLE_ROW_CLICK": "Clique duas vezes para ir aos detalhes do pedido!",
      "TABLE_UPDATED": "Lista de Compras atualizada"
    },
    "DETAILS": {
      "DETAILS": "Detalhes da Compra",
      "DOWNLOAD_BUTTON_GROUP": {
        "DOWNLOAD_INVOICE": "Baixar Nota Fiscal",
        "DOWNLOAD_BANK_SLIP": "Baixar Boleto"
      },
      "STATEMENT": {
        "DOWNLOAD_CSV": "Baixar extrato da compra",
        "DOWNLOAD_CLOUD_STATEMENT": "Baixar Statement"
      },
      "STATUS": {
        "PROCESSING": "Processando",
        "PROCESSED": "Este pedido se encontra liberado para faturamento.",
        "INVOICED": "Todos os itens deste pedido foram faturados, ou seja, já possuem nota ou notas fiscais.",
        "PARTIALLY_INVOICED": "Alguns itens deste pedido já foram faturados, ou seja, já possuem nota fiscal.",
        "SHIPPED": "Enviado",
        "PARTIALLY_SHIPPED": "Parcialmente Enviado",
        "DELIVERED": "Entregue",
        "PARTIALLY_DELIVERED": "Parcialmente Entregue",
        "CANCELED": "Cancelado",
        "PARTIALLY_CANCELED": "Parcialmente Cancelado",
        "DELAYED": "Atrasado",
        "PARTIALLY_DELAYED": "Parcialmente Atrasado",
        "PAID": "Todos itens deste pedido já estão com notas 100% pagas",
        "PARTIALLY_PAID": "Em algumas notas deste pedido constam parcelas pagas"
      }
    },
    "COMMANDS": {
      "EXPORT_ALL": "Exportar Compras"
    }
  },
  "FORM_VALIDATION": {
    "REQUIRED": "CAMPO OBRIGATÓRIO",
    "EMAIL": "DEVE SER UM E-MAIL VÁLIDO",
    "COMPANY_DATA": "DEVE SER UM CNPJ VÁLIDO",
    "PHONE_NUMBER": "DEVE SER UM N.º DE TELEFONE VÁLIDO",
    "INVALID_EMAIL": "E-mail inválido",
    "REQUIRED_FIELD": "Este campo é obrigatório.",
    "INVALID_DOCUMENT": "DEVE SER UM CPF VÁLIDO"
  },
  "HELP_MODAL": {
    "HEADER": {
      "TITLE": "Precisa de ajuda?",
      "SUBTITLE": "Lamentamos que esteja com problemas. Nossa equipe analisará sua mensagem e entrará em contato em breve."
    },
    "ALERT": {
      "VALIDATION_MESSAGE": "Verifique se os campos obrigatórios estão vazios",
      "SUCCESS_MESSAGE": "Formulário enviado com sucesso"
    }
  },
  "ACCESS_CONTROL": {
    "INVALID_CNPJ": "Documento inválido, por favor informe um CNPJ válido.",
    "ERROR_404": "Não foi possível realizar a solicitação, por favor tente novamente mais tarde.",
    "REQUEST_ACCESS_BUTTON": "Solicitar Acesso",
    "REQUEST_ACCESS_TITLE": "Para solicitar acesso a um novo grupo econômico, digite o CNPJ abaixo.",
    "REQUEST_ACCESS_SUCCESS_PARAGRAPH_1": "Solicitação realizada com sucesso!",
    "REQUEST_ACCESS_SUCCESS_PARAGRAPH_2": "Empresa já disponível na lista de CNPJs nos quais você tem acesso.",
    "REQUEST_ACCESS_SUCCESS_ACCESS_GRANTED_PARAGRAPH_1": "Solicitação de acesso enviada para",
    "REQUEST_ACCESS_SUCCESS_ACCESS_GRANTED_PARAGRAPH_2": "com sucesso!",
    "REQUEST_ACCESS_SUCCESS_ACCESS_GRANTED_PARAGRAPH_3": "Este pedido tem validade de 5 dias. Caso após este prazo não tenha um retorno, por favor, realizar nova solicitação.",
    "LINK_NEW_COMPANY": "Vincular nova empresa",
    "REQUEST_RESPONSE_SCREEN": {
      "SUCCESS_MESSAGE_PARAGRAPH_1": "Resposta registrada.",
      "SUCCESS_MESSAGE_PARAGRAPH_2": "Agradecemos sua colaboração!",
      "AGREE": "CONCORDO",
      "DO_NOT_AGREE": "NÃO CONCORDO",
      "REQUEST_RESPONSE_TEXT_PART_1": "Eu, portador do e-mail ",
      "REQUEST_RESPONSE_TEXT_PART_2": ", concordo com a concessão de acesso como perfil de administrador no sistema MyScanSource para ",
      "REQUEST_RESPONSE_TEXT_PART_3": ", email ",
      "REQUEST_RESPONSE_TEXT_PART_4": ", na empresa ",
      "REQUEST_RESPONSE_TEXT_PART_5": ", CNPJ ",
      "REQUEST_RESPONSE_TEXT_PART_6": "A partir do meu aceite, concedo o acesso total a esta empresa e suas respectivas filiais, se houver, para visualizar pedidos e seus detalhes, e também ter acesso às notas fiscais e boletos dos mesmos.",
      "RESPONSE_ALREADY_ANSWERED_PART_1": "Esta solicitação já foi ",
      "RESPONSE_ALREADY_ANSWERED_PART_2": " e não pode ser alterada. Caso a ação tenha sido realizada por engano, entre em contato conosco pelo formulário de suporte.",
      "RESPONSE_WITH_ERROR": "Houve um erro em sua resposta, por gentileza, tente novamente mais tarde.",
      "RESPONSE_WITH_ERROR_404": "Não foi possível encontrar esta solicitação"
    }
  },
  "INVOICES": {
    "FILTER_OPTIONS": {
      "INVOICE_NUMBER": "N.° da nota fiscal",
      "INVOICE_SERIE": "N.º de série",
      "INVOICE_PART_NUMBER": "Id do Produto",
      "SALES_ORDER": "N.º da compra",
      "BILLING_PERIOD": "Período de faturamento",
      "ORDER_NUMBER": "N.º da compra",
      "INVOICE_STATUS": "Status",
      "PLACEHOLDER": {
        "FILTERED_FIELD": "Consultar por",
        "EMPTY": "Selecione uma opção a esquerda",
        "DUE_PERIOD": "Período de faturamento",
        "INVOICE_STATUS": "Status"
      },
      "TIP": {
        "FILTERED_FIELD": "Nota fiscal, N° de série ou N° da compra",
        "GENERIC_TERM": "Preencha com o dado escolhido a esquerda",
        "DUE_DATE": "Selecione o período do faturamento ou apenas uma data",
        "SEARCH": "Buscar",
        "CLEAR": "Limpar",
        "INVOICE_STATUS": "Status da NF"
      }
    },
    "FILTER_PRODUCT_TYPE": {
      "PLACEHOLDER": "Tipo de Produto",
      "TIP": "Selecione o tipo do produto"
    },
    "PRODUCT_TYPE": {
      "ALL": "Todos",
      "HARDWARE": "Hardware",
      "SOFTWARE_SERVICE_CLOUD": "Software/Service/Cloud"
    },
    "LABEL": "Consulta de Notas Fiscais",
    "LIST": {
      "TABLE": {
        "HEADERS": {
          "NUMBER": "N.º da Nota Fiscal",
          "ORDER": "N.º da compra",
          "BILLING_DATE": "Data de faturamento",
          "FINAL_CLIENT_DOCUMENT": "CPF/CNPJ Cliente Final",
          "FINAL_CLIENT_NAME": "Cliente Final",
          "PRODUCT_TYPE": "Tipo de Produto",
          "INVOICE_STATUS": "Situação"
        },
        "TOOLTIPS": {
          "DOWNLOAD_NF": "Baixar Nota Fiscal",
          "DOWNLOAD_CLOUD_STATEMENT": "Baixar Statement",
          "GO_TO_ORDERS": "Ir para os detalhes desta compra"
        }
      }
    },
    "FILTER_MORE": {
      "LABEL": "Outros Filtros"
    }
  },
  "CONTACTS": {
    "TITLE": "Contato",
    "ASK": {
      "1STLINE": "Qual das opções abaixo se",
      "SECOND_LINE": "encaixa na sua necessidade?"
    },
    "CARDS": {
      "FIRST_CARD": {
        "TITLE": "Contato via whatsapp",
        "1STLINE": "Entre em contato pelo nosso"
      },
      "SECOND_CARD": {
        "TITLE": "Mandar uma mensagem",
        "1STLINE": "Use nosso formulário de contato, e nós entraremos em contato com você o mais rápido possível.",
        "LINK": "Entrar em contato"
      }
    },
    "WHITE_SECTION": {
      "TITLE": "Equipe de atendimento",
      "SUBTITLE": "fale com a nossa",
      "TABLE": {
        "NAME": "Nome",
        "EMAIL": "E-mail",
        "PROFILE": "Perfil"
      }
    }
  },
  "ORDER": {
    "FILTER": {
      "TIP": "Outros Filtros"
    },
    "FILTER_SEARCH": {
      "LABEL": "aplicar filtro",
      "TIP": "Buscar"
    },
    "FILTER_CLEAR": {
      "TIP": "Limpar"
    },
    "FILTER_MORE": {
      "LABEL": "Filtros"
    },
    "FILTER_DATE": {
      "PLACEHOLDER": ""
    }
  },
  "ECONOMIC_GROUP_HEADQUARTER": "Matriz",
  "ECONOMIC": {
    "GROUP": {
      "HEADQUARTER": "Matriz",
      "COMPANY_BRANCH": "Filial",
      "CANCEL_BUTTON": "Acessar",
      "ACCESS_BUTTON": "cancelar",
      "APPLY_BUTTON": "Aplicar"
    }
  },
  "PAYMENT_SLIP": {
    "FILTER_OPTIONS": {
      "ORDER_NUMBER": "Nº Compra",
      "FINAL_CUSTOMER_DOCUMENT": "CNPJ Cliente Final",
      "INVOICE_NUMBER": "N.° da nota fiscal",
      "FILTERS": "Filtros",
      "PLACEHOLDER": {
        "FILTERED_FIELD": "Consultar por",
        "EMPTY": "Selecione uma opção a esquerda"
      },
      "TIP": {
        "FILTERED_FIELD": "N° da compra, CNPJ do cliente final ou N° da Nota",
        "GENERIC_TERM": "Preencha com o dado escolhido a esquerda"
      }
    },
    "FILTER_DATE": {
      "PLACEHOLDER": "Período de Vencimento",
      "TIP": "Selecione o período de vencimento ou apenas uma data"
    },
    "FILTER_PAYMENT_DATE": {
      "PLACEHOLDER": "Período de Pagamento",
      "TIP": "Selecione o período de pagamento ou apenas uma data"
    },
    "FILTER_PRODUCT_TYPE": {
      "PLACEHOLDER": "Tipo de Produto",
      "TIP": "Selecione o tipo do produto"
    },
    "FILTER_SEARCH": {
      "LABEL": "aplicar filtro",
      "TIP": "Buscar"
    },
    "FILTER_CLEAR": {
      "TIP": "Limpar filtros",
      "LABEL": "Limpar"
    },
    "PRODUCT_TYPE": {
      "ALL": "Todos",
      "HARDWARE": "Hardware",
      "SOFTWARE_SERVICE_CLOUD": "Software/Service/Cloud"
    }
  },
  "ERR": {
    "COMPANY_DOCUMENT": {
      "EMPTY": "CNPJ da revenda vazio, faça login novamente"
    },
    "RESELLER_DOCUMENT": {
      "EMPTY": "CNPJ da revenda é requerido",
      "INVALID": "CNPJ da revenda inválido, faça login novamente e, caso persista, pessa ajuda ao seu admin ou acione o suporte",
      "NOT_MATCH": "CNPJ não compatível, selecione a revenda desejada."
    }
  },
  "EXCEPTIONS": {
    "NOT_FOUND": "Não é possível realizar a solicitação de acesso para este CNPJ, pois ele ainda não consta na nossa base de Revendas",
    "MY_SCANSOURCE_UI": {
      "FILTERS_CANNOT_BE_EMPTY": "Não é possível realizar a busca com campos vazios.",
      "GENERIC_TERM_REQUIRED": "Para realizar a busca, você precisa preencher o campo de dados.",
      "INVALID_COMPANY_DOCUMENT": "O CNPJ informado não é válido.",
      "INVALID_DOCUMENT": "O documento informado não é válido.",
      "END_DATE_CANNOT_BE_BEFORE_START_DATE": "A data final não pode ser anterior a data inicial.",
      "SHOULD_BE_A_COMPANY_DOCUMENT": "O CPF/CNPJ informado precisa ser válido.",
      "INTERNAL": {
        "INVALID_DATE_START": "Data inicial inválida.",
        "INVALID_DATE_END": "Data final inválida."
      }
    },
    "MYSCANSOURCEMANAGERSERVICE": {
      "REQUESTSSERVICE": {
        "COMPANYNOTFOUND": "Não é possível realizar a solicitação de acesso para este CNPJ, pois ele ainda não consta na nossa base de Revendas",
        "COMPANYCONTACTEMAILNOTFOUND": "Não é possível realizar a solicitação de acesso para este CNPJ, pois ele ainda não consta na nossa base de Revendas",
        "THISUSERISALREADYPARTOFTHISECONOMICGROUP": "Você já possui acesso a este CNPJ",
        "COMPANYDOCUMENTINFORMEDMUSTBEHEADQUARTER": "CNPJ informado deve ser de uma matriz"
      },
      "COMPANIESSERVICE": {
        "COMPANYNOTFOUND": "Empresa não encontrada.",
        "INVALIDBUYERDATA": "Dados do cliente final inválidos.",
        "INVALIDDOCUMENT": "Documento inválido.",
        "INVALIDEMAIL": "E-mail inválido.",
        "INVALIDTOKEN": "Token inválido.",
        "THISRESELLERALREADYHASADMUSER": "A revenda já tem permissão de administrador.",
        "USERNOTFOUNDWITHTHISTOKEN": "Não foi possível encontrar usuário com esse token."
      },
      "CUSTOMERSPROTFOLIOSERVICE": {
        "CUSTOMERPORTFOLIONOTFOUND": "Relatório do usuário não encontrado.",
        "INVALIDCOMPANYDOCUMENT": "N.º CNPJ inválido."
      },
      "USERSSERVICE": {
        "ISNOTPOSSIBLETOMAKENEWREQUESTFORTHECOMPANYDOCUMENTBECAUSEASTHEREISALREADYOPENREQUEST": "Não é possível realizar uma nova solicitação para a empresa {CNPJ}, pois já existe uma solicitação em aberto",
        "THISUSERCANNOTBEINVITEDBECAUSETHEYALREADYHAVEACCESSTOTHEINFORMEDCOMPANYDOCUMENT": "Este e-mail já se econtra cadastrado nesta Revenda.",
        "THISUSERISALREADYMASTERRESELLERWITHCNPJ": "Já existe uma revenda vinculada para este e-mail.",
        "ANONMASTERUSERCANONLYCHANGETHEIRREGISTRATION": "Somente o administrador pode alterar os dados de outros usuários.",
        "COMPANYDOCUMENTFILTEREDNOTFOUNDINCOMPANYROLELIST": "CNPJ filtrado não foi encontrado na lista de permissões do usuário",
        "COMPANYMISMATCH": "O administrador e o usuário informado não pertencem a mesma empresa.",
        "COMPANYNOTFOUND": "Empresa não encontrada.",
        "DOCUMENTALREADYINUSE": "O documento informado já está em uso.",
        "INVALIDFIRSTNAME": "Nome não é válido.",
        "INVALIDLASTNAME": "Sobrenome não é válido.",
        "INVALIDCOMPANYDOCUMENT": "O CNPJ informado não é válido.",
        "INVALIDDOCUMENT": "Documento não é válido.",
        "INVALIDEMAIL": "E-mail não é válido.",
        "INVALIDPHONENUMBER": "N.º de telefone inválido",
        "INVALIDTOKEN": "Token inválido.",
        "LOGGEDUSERISNOTMASTERUSER": "O usuário logado não é administrador.",
        "OPTINPRIVACYUNMARKED": "Para prosseguir, é necessário aceitar os termos e política de privacidade.",
        "THEREISALREADYUSERWITHTHISEMAIL": "Já existe um usuário com o e-mail informado.",
        "THEREISNOUSERWITHTHISID": "Não existe usuário com esse ID.",
        "THISEMAILALREADYEXISTSINCOMPANYWITHCNPJ": "O e-mail informado já está relacionado ao CNPJ informado.",
        "THISEMAILUSESDOMAINTHATISNOTPERMITTED": "O email informado vem de um domínio não permitido.",
        "THISRESELLERALREADYHASADMUSER": "Essa revenda já possui um usuário administrador.",
        "THISUSERALREADYPARTOFANOTHERECONOMICGROUP": "Este usuário faz parte de outro grupo econômico, e não é possível adicioná-lo a mais de um grupo econômico.",
        "THISCOMPANYDOCUMENTALREADYEXISTS": "Este usuário já foi convidado.",
        "USERALREADYEXISTS": "Já existe um usuário cadastrado com o CPF informado.",
        "USERMASTERANDUSERUPDATETHEYARENOTINSAMEECONOMICGROUP": "O administrador e o usuário em edição, não fazem parte do mesmo grupo econômico.",
        "USERMASTERNOTFOUND": "Não foi possível encontrar usuário administrador.",
        "USERNOTFOUND": "Usuário não encontrado.",
        "USERNOTFOUNDWITHTHISTOKEN": "Não foi possível encontrar usuário com este token.",
        "THISUSERALREADYHASACCESTOTHISRESELLER": "Este e-mail já consta neste Grupo Econômico."
      },
      "SUPPORTSSERVICE": {
        "REQUIREDCOMPANYDOCUMENT": "É obrigatório informar o CNPJ.",
        "INVALIDEMAIL": "E-mail informado não é válido."
      },
      "ORDERSSERVICE": {
        "INVALIDDATERANGE": "O intervalo entre datas é inválido.",
        "INVALIDORDERVALUE": "N.º da compra inválida.",
        "INVOICENOTFOUNDWITHTHEPROVIDEDPARAMETERS": "Desculpe, não encontramos nenhuma nota correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa.",
        "INVOICENUMBERMUSTCONTAINONLYNUMERICALCHARACTERS": "O N.º da nota fiscal deve ter apenas N.ºs.",
        "NOPAYMENTSLIPWASFOUNDWITHTHEGIVENPARAMETERS": "Desculpe, não encontramos nenhum boleto correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa.",
        "ORDERNOTFOUND": "Compra não encontrada.",
        "ORDERNOTFOUNDWITHTHEPROVIDEDPARAMETERS": "Desculpe, não encontramos nenhuma compra correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa.",
        "THEORDERWITHTHISNUMBERDOESNOTCONTAINANYINVOICE": "Não foi encontrado nenhuma compra com o N.º informado.",
        "NOCONTENT": "Não se preocupe, está tudo conforme esperado. Só não existem compras para exibir."
      },
      "KEYCLOAKSERVICE": {
        "FAILEDTOCREATEUSERACCOUNT": "Não foi possível criar a conta. Pro favor, tente novamente mais tarde.",
        "FAILEDTOADDUSERTOTHEGROUP": "Falha ao adicionar usuário ao grupo.",
        "ALREADYEXISTSUSERWITHSAMEUSERNAME": "O nome de usuário já foi cadastrado."
      },
      "PAYMENTSSERVICE": {
        "INVOICENOTFOUND": "Os arquivos da nota fiscal ainda estão em preparação, por favor, tente novamente em alguns minutos.",
        "PAYMENTSLIPNOTFOUND": "Os arquivos do boleto ainda estão em preparação, por favor, tente novamente em alguns minutos."
      },
      "INVOICESSERVICE": {
        "ORDERNOTFOUNDWITHTHEPROVIDEDPARAMETERS": "Desculpe, não encontramos nenhuma nota correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa., ",
        "NOCONTENT": "Não se preocupe, está tudo conforme o esperado. Só não existem notas fiscais para exibir ainda."
      },
      "PAYMENTSLIPSERVICE": {
        "ORDERNOTFOUNDWITHTHEPROVIDEDPARAMETERS": "Desculpe, não encontramos nenhum boleto correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa.",
        "NOCONTENT": "Não se preocupe, está tudo conforme esperado. Só não existem boletos para exibir."
      }
    },
    "SERVER": {
      "INTERNALERROR": "Desculpe o incomodo mas, houve um pequeno erro e por isso não conseguimos trazer sua informação agora.\nFique tranquilo, pois já estamos trabalhando em uma solução!\nPor gentileza, tente novamente em alguns minutos e, se persistir o erro, não deixe de nos informar."
    },
    "USERS": {
      "REGISTER": {
        "PHONE_NUMBER": "Verifique o campo Telefone",
        "DOCUMENT": "Verifique o campo CPF!",
        "FIRST_NAME": "Verifique o campo Nome",
        "LAST_NAME": "Verifique o campo Sobrenome",
        "EMAIL": "Verifique o campo E-mail",
        "INVALID_DOCUMENT": "Documento inválido",
        "NOT_AVAILABLE_INVITATION_CODE": "Código de convite  já utilizado ou não disponível.",
        "OPT_IN_PRIVACY": "Você deve aceitar os termos de privacidade para se cadastrar.",
        "BIRTH_DATE": "Verifique o campo Data de nascimento!",
        "LEGAL_AGE": "Por motivos de política de privacidade, não podemos efetuar um cadastro de menor de 18 anos."
      }
    },
    "INVOICES": {
      "DOWNLOAD": {
        "NO_URLS_DONE": "Os arquivos da nota fiscal ainda estão em preparação, por favor, tente novamente em alguns minutos.",
        "AUTHORISE_POPUP_BLOCKED": "Pode ser necessário autorizar a abertura de pop-ups para baixar o arquivo."
      }
    },
    "PAYMENT_SLIPS": {
      "DOWNLOAD": {
        "NO_URLS_DONE": "Os arquivos do boleto ainda estão em preparação, por favor, tente novamente em alguns minutos.",
        "AUTHORISE_POPUP_BLOCKED": "Pode ser necessário autorizar a abertura de pop-ups para baixar o arquivo."
      }
    },
    "FORM_VALIDATION": {
      "REQUIRED": {
        "TEXT": "Campo obrigatório.",
        "DATE": "Data obrigatória.",
        "EMAIL": "E-mail obrigatório.",
        "COMPANY_DOCUMENT": "CNPJ obrigatório.",
        "PHONE_NUMBER": "Telefone obrigatório.",
        "PERSONAL_DOCUMENT": "CPF obrigatório.",
        "PROFILE": "Perfil obrigatório.",
        "PRIVACY": "Aceite os termos de privacidade."
      },
      "INVALID": {
        "EMAIL": "E-mail inválido.",
        "COMPANY_DOCUMENT": "CNPJ inválido.",
        "PHONE_NUMBER": "Telefone inválido.",
        "PERSONAL_DOCUMENT": "CPF inválido."
      }
    },
    "PROFILE": {
      "STATUS": {
        "DISABLED": {
          "TITLE": "Seu usuário não tem acesso permitido!",
          "TEXT": "Por isso você será desconectado.\nVocê pode tentar fazer login novamente ou contatar o administrador do seu Grupo Econômico para verificar seu status de acesso.\nCaso você seja o administrador, por gentileza, entre em contato e o ajudaremos."
        }
      }
    },
    "UNEXPECTED": "Parece que encontramos um erro ao processar sua pesquisa. Por favor, tente novamente mais tarde ou entre em contato para assistência.",
    "UNEXPECTED_FILE": "Parece que encontramos um erro ao disponibilizar este arquivo. Por favor, tente novamente mais tarde ou entre em contato para assistência.",
    "UI": {
      "USERS": {
        "EDIT": {
          "USER_NOT_FOUND": "Usuário solicitado não foi encontrado ou não existe."
        }
      }
    }
  },
  "USERS_FORM": {
    "FIRST_NAME": "Nome",
    "LAST_NAME": "Sobrenome",
    "EMAIL": "E-mail",
    "PROFILE": "Perfil",
    "DOCUMENT": "CPF",
    "PHONE_NUMBER": "Telefone",
    "PRIVACY": "Privacidade",
    "SUBMIT": "Salvar"
  },
  "TOAST": {
    "SUMMARY": {
      "INFO": "Importante!",
      "WARN": "Atenção!",
      "ERROR": "Ops!",
      "SUCCESS": "Tudo Ok!",
      "NO_CONTENT": "Ainda não há conteúdo para mostrar.",
      "NO_INVOICES": "Sem Notas Fiscais por enquanto..."
    },
    "DETAILS": {
      "ERROR_CODE": "CÓDIGO:",
      "NO_CONTENT": "Talvez seja um bom momento para um cafezinho!",
      "NO_INVOICES": "As notas para esta compra, ainda não foram emitidas.",
      "NO_DATA_FILTERED": "Desculpe, não encontramos nenhum conteúdo correspondente aos critérios da sua busca. Por favor, tente novamente com palavras-chave diferentes ou refine a sua pesquisa."
    },
    "TITLE": {
      "NO_CONTENT": "Não há nada aqui."
    },
    "DDETAILS": {
      "NO_INVOICES": "Por enquanto não temos Notas Fiscais disponíveis."
    }
  },
  "phoneNumber": "Dado incorreto: Telefone",
  "firstName": "Dado incorreto: Nome",
  "lastName": "Dado incorreto: Sobrenome",
  "email": "Dado incorreto: E-mail",
  "birthDate": "Dado incorreto: Data de nascimento",
  "DASHBAORD": {
    "LAST_ORDER_DETAILS_LINK": "Último Compra"
  },
  "ORDER_NUMBER": "N.º da compra",
  "FIELD_SALES": "Vendedor",
  "FIELD_SALES_MANAGER": "Gerente",
  "SALES_PERSON": "Vendedor",
  "RESPONSIBLE_SALES_PERSON": "Gerente",
  "NAVBAR": {
    "PROFILE": {
      "ASK_FOR_HELP": {
        "SUMMARY": "Solicitar ajuda",
        "TEXT": "Não deixe de entrar em contato, caso precise de ajuda."
      },
      "HANDLE_USERS": {
        "SUMMARY": "Administrar usuários",
        "TEXT": "Mantenha os cadastros atualizados"
      },
      "TIP": "Perfil",
      "CONTACT": {
        "SUMMARY": "Fale com o time de vendas",
        "TEXT": "Fale com um de nossos vendedores"
      }
    }
  },
  "HELP_FORM": {
    "TOAST": {
      "SUMMARY": {
        "SUCCESS": "Solicitação enviada!",
        "ERROR": "Falha ao enviar sua solicitação."
      },
      "DETAILS": {
        "SUCCESS": "Logo alguém entrará em contato."
      }
    }
  },
  "PRE_LOGIN": {
    "ACCESS_MYSCAN": "Acessar MyScanSource",
    "BACK_TO_ACCESS_MYSCAN": "Voltar para o MyScanSource",
    "PARAGRAPH_LOGOUT": "Agradecemos por ter acessado o MyScanSource!",
    "GO_TO_SITE": "Ir para o site ScanSource",
    "PARAGRAPH_LOGOUT_UNAVAILABLE_ONE": "Estamos enfrentando uma pequena instabilidade no sistema no momento. Pedimos desculpas pelo transtorno e recomendamos que você tente logar novamente mais tarde.",
    "PARAGRAPH_LOGOUT_UNAVAILABLE_TWO": "Agradecemos pela sua compreensão!",
    "PARAGRAPH_IS_NOT_ALLOWED_ONE": "Olá!",
    "PARAGRAPH_IS_NOT_ALLOWED_TWO": "Infelizmente, você não tem permissão para acessar o MyScanSource.",
    "PARAGRAPH_ONE": "Te damos as boas-vindas ao MyScanSource, um ecossistema de serviços Pós-vendas que foi criado para revolucionar a forma como você se conecta com seus clientes.",
    "PARAGRAPH_TWO": "Com visualização personalizada, central de informações e muito mais, o MyScanSource oferece a autonomia e eficiência que sua revenda precisa.",
    "PARAGRAPH_THREE": "Neste momento, por estarmos numa fase de implementação da plataforma, o acesso está sendo disponibilizado de forma gradual. Em breve, poderemos expandir o acesso para todas as nossas revendas parceiras. Fique de olho nos nossos canais de comunicação para saber as atualizações.",
    "PARAGRAPH_IS_NOT_ALLOWED_THREE": "Tente uma das opções abaixo.",
    "PARAGRAPH_LOGOUT_TWO": "Até o próximo login!"
  },
  "PAGINATE": {
    "NO_DATA": "Isso é tudo",
    "PAGINATE": "Ver mais"
  },
  "numberBankslip": "N.º do Boleto",
  "invoiceNumber": "N.º da NF",
  "productType": "Tipo do Produto",
  "installmentDueDate": "Data de Vencimento",
  "installmentPaymentDate": "Data de pagamento",
  "order": "Compra",
  "client": "Cliente",
  "clientDocument": "Documento",
  "BANNER_DEFAULT_SUBTITLE": "Tenha acesso a um ecossistema de informações sobre o pós-venda de sua revenda.",
  "BANNER_DEFAULT_TITLE": "MyScansource",
  "MY_SCANSOURCE": "MyScanSource",
  "INVITE_USER": {
    "TITLE": "Cadastro de dados pessoais",
    "SUBTITLE": "Seja bem vindo ao time!"
  },
  "": "",
  "CompanyBranch": "",
  "Headquarter": "",
  "ManagerReseller": "",
  "CommercialReseller": "",
  "access": "",
  "active": "",
  "button": {
    "about": "",
    "access": {
      "my-scansource": ""
    },
    "access_my_scansource": "",
    "back": "",
    "go": "",
    "home": "",
    "request_quote": "",
    "toggle_dark": "",
    "toggle_langs": ""
  },
  "changePassword": "",
  "clients": {
    "_add": {
      "form": {
        "cpf": "",
        "email": "",
        "name": "",
        "phone": "",
        "surname": ""
      }
    },
    "add": {
      "cardTitle": "",
      "errorMessage": {
        "multiple": "",
        "single": ""
      },
      "form": {
        "SSN": "",
        "companyName": "",
        "confirmPassword": "",
        "email": "",
        "lastName": "",
        "name": "",
        "password": "",
        "phone": "",
        "profile": "",
        "submit": "",
        "taxId": ""
      },
      "label": ""
    },
    "button": {
      "add": ""
    },
    "label": "",
    "table": {
      "headers": {
        "actions": "",
        "createdAt": "",
        "email": "",
        "name": "",
        "status": "",
        "userType": ""
      },
      "title": ""
    }
  },
  "contacts": {
    "ask": {
      "1stline": "",
      "secondline": ""
    },
    "cards": {
      "firstCard": {
        "1stline": "",
        "title": ""
      },
      "secondCard": {
        "1stline": "",
        "link": "",
        "title": ""
      }
    },
    "title": "",
    "whiteSection": {
      "subtitle": "",
      "table": {
        "email": "",
        "name": "",
        "profile": ""
      },
      "title": ""
    }
  },
  "dashboard": {
    "banner": {
      "subtitle": "",
      "title": ""
    },
    "customerService": {
      "firstParagraph": "",
      "secondParagraph": "",
      "thirdParagraph": "",
      "title": ""
    },
    "label": {
      "action": {
        "economic_group": ""
      }
    }
  },
  "economicGroupCompanyList": {
    "columns": {
      "cnpj": "",
      "name": "",
      "type": ""
    },
    "header": {
      "cnpj": "",
      "companyType": "",
      "name": ""
    },
    "summary": "",
    "title": ""
  },
  "errors": {
    "submit": {
      "_422": ""
    }
  },
  "fake_link": "",
  "forms": {
    "error": {
      "submit": {
        "message": "",
        "title": ""
      }
    },
    "errors": {
      "invalidSubmit": "",
      "submit": {
        "message": "",
        "title": ""
      }
    },
    "success": {
      "submit": ""
    }
  },
  "home": {
    "alert": {
      "access-my-scansource": {
        "offline": {
          "title": ""
        }
      }
    }
  },
  "inactive": "",
  "lgpd": {
    "footer": "",
    "label": "",
    "link_text": "",
    "message": "",
    "required_message": ""
  },
  "mega_menu": {
    "description": {
      "business_info": {
        "subtitle": ""
      },
      "client_success": {
        "subtitle": ""
      },
      "solutions": {
        "descriptiveText": "",
        "subtitle": ""
      }
    },
    "options": {
      "business_info": "",
      "client_success": "",
      "solutions": ""
    }
  },
  "needLogin": {
    "message": "",
    "title": ""
  },
  "nextSteps": {
    "banner": {
      "subtile": "",
      "subtitle": "",
      "title": ""
    },
    "completeConfirm": {
      "firstText": "",
      "fouthText": "",
      "noEmail": "",
      "secondText": "",
      "thirdText": ""
    }
  },
  "orders": {
    "bill": "",
    "clientName": "",
    "created": "",
    "details": "",
    "detailsOrders": {
      "detailsByInvoice": {
        "chart-file": "",
        "detailsBytaxes": {
          "cofinsPercent": "",
          "cofinsValue": "",
          "icms": "",
          "icmsPercent": "",
          "ipiPercent": "",
          "ipiValue": "",
          "issPercent": "",
          "issValue": "",
          "pisPercent": "",
          "pisValue": ""
        },
        "extract": "",
        "invoicedItem": "",
        "invoicedTable": {
          "amount": "",
          "customerBilling": "",
          "product": "",
          "resellerBilling": ""
        },
        "items": "",
        "status": "",
        "subtitle": "",
        "taxes": "",
        "title": "",
        "unBilledItems": "",
        "unBilledTable": {
          "amount": "",
          "description": "",
          "items": ""
        }
      },
      "finalCustomerName": "",
      "invoice": "",
      "netCommission": "",
      "orderNumber": "",
      "paymentMethod": "",
      "proposalNumber": "",
      "purchaseOrderNumber": "",
      "resellerName": "",
      "shippingCommission": "",
      "shippingRate": "",
      "statement": {
        "invoiceDetails": ""
      },
      "statusByInvoice": "",
      "title": "",
      "totalByInvoices": ""
    },
    "invoice": "",
    "label": "",
    "number": "",
    "status": ""
  },
  "sentences": {
    "clickHere": ""
  },
  "users": {
    "add": {
      "cardTitle": "",
      "form": {
        "SSN": "",
        "companyName": "",
        "confirmPassword": "",
        "email": "",
        "errorMessage": {
          "multiple": "",
          "single": ""
        },
        "lastName": "",
        "name": "",
        "password": "",
        "phone": "",
        "phoneNumber": "",
        "profile": "",
        "submit": "",
        "taxId": ""
      },
      "label": "",
      "noDataText": "",
      "success": {
        "message": ""
      }
    },
    "button": {
      "add": ""
    },
    "form": {
      "document": "",
      "edit": {
        "submit": "",
        "updatePassword": ""
      },
      "email": "",
      "firstName": "",
      "lastName": "",
      "phoneNumber": "",
      "profileType": "",
      "profileTypePlaceholder": "",
      "status": ""
    },
    "forms": {
      "errors": {
        "submit": {
          "notFound": ""
        }
      }
    },
    "label": "",
    "table": {
      "headers": {
        "actions": "",
        "createdDate": "",
        "email": "",
        "name": "",
        "profileType": "",
        "status": ""
      },
      "summary": "",
      "title": ""
    }
  },
  "words": {
    "clickHere": "",
    "field": "",
    "fields": "",
    "user": ""
  },
  "ROUTES": {
    "LABEL": {
      "MY_ACCOUNT": "Minha Conta",
      "MY-ACCOUNT-BALANCE-STATEMENT": "Saldo e Extrato",
      "BALANCE_STATEMENT": "Saldo e Extrato",
      "MY-ACCOUNT-REDEMPTIONS": "Meus Resgates",
      "MY_REDEMPTIONS": "Meus Resgates",
      "DASHBOARD": "Dashboard",
      "ORDERS": "Minhas Compras",
      "ALL_ORDERS": "Todas as Compras",
      "INVOICES": "Notas Fiscais",
      "BILLS": "Boletos",
      "PAYMENT-SLIPS": "Boletos",
      "COMMISSIONS": "Meus Agenciamentos",
      "CONTACTS": "Contato",
      "USERS": "Usuários"
    }
  },
  "INVOICE": {
    "LIST": {
      "TABLE_UPDATED": "Lista de notas fiscais foi atualizada"
    }
  },
  "PAYMENT_SLIPS": {
    "LIST": {
      "TABLE_UPDATED": "Lista de boletos foi atualizada"
    }
  },
  "NET_COMMISSION": "Valor Líquido",
  "NO_COMMISSIONS": "Não existem comissões para exibir",
  "LOAD_MORE_RESULTS": "Carregar mais resultados",
  "INVOICE_NUMBER": "Nº da Nota Fiscal",
  "INVOICE_SERIE": "Série da Nota Fiscal",
  "COMPANY_DOCUMENT": "C.N.P.J.",
  "FINAL_CUSTOMER_NAME": "Nome do Cliente",
  "BALANCE_STATEMENT": {
    "FILTERS": {
      "DATA": {
        "LAST_5_DAYS": "Últimos 5 dias",
        "15_DAYS": "15 dias",
        "30_DAYS": "30 dias",
        "3_MONTHS": "3 meses",
        "6_MONTHS": "6 meses",
        "PER_PERIOD": "Por período"
      },
      "PLACEHOLDER": "O que deseja buscar?"
    },
    "LIST": {
      "DATE": "Data",
      "RELEASES": "Lançamentos",
      "VALUE": "Valor (R$)"
    },
    "TABS": {
      "FULL": "Completo",
      "ENTRIES": "Entradas",
      "EXITS": "Saídas"
    }
  },
  "COMMISSIONS": {
    "FILTER_OPTIONS": {
      "TIP": {
        "FILTERED_FIELD": "Selecione uma das opções",
        "INVOICE_STATUS": "Selecione o status desejado",
        "PAYMENT_DATE": "Selecione o intervalo de Data de Pagamento",
        "DUE_DATE": "Selecione o intervalo de Data de Vencimento"
      },
      "PLACEHOLDER": {
        "INVOICE_STATUS": "Status da comissão",
        "PAYMENT_PERIOD": "Data de Pagamento",
        "DUE_PERIOD": "Data de Vencimento"
      }
    },
    "DETAILS": {
      "HEADER": "Detalhes da comissão",
      "INVOICE_DETAILS": "Detalhes referentes a nota fiscal",
      "DETAILS_BY_INSTALlMENTS": "Detalhes por parcelamento",
      "DETAILS_BY_ITEMS_OR_FEES": "Detalhes por item / taxas"
    },
    "STATUS": {
      "TO_RECEIVE": {
        "LABEL": "A Receber",
        "TIP": "Aguardando pagamento do cliente"
      },
      "AVAILABLE": {
        "LABEL": "Disponível",
        "TIP": "Disponível para resgate"
      },
      "REQUESTED": {
        "LABEL": "Solicitada",
        "TIP": "Solicitação de crédito realizada"
      },
      "CREDITED": {
        "LABEL": "Creditada",
        "TIP": "Valor da comissão já creditada"
      },
      "EXPIRED": {
        "LABEL": "Expirada",
        "TIP": "Prazo de solicitação expirado.\nNão é possível solicitar o crédito."
      },
      "PREVIEW": {
        "LABEL": "Prévia",
        "TIP": "Antecipação do valor da comissão"
      },
      "REVERSED": {
        "LABEL": "Estornada",
        "TIP": "Valor Estornado por cancelamento na venda"
      },
      "PAID": {
        "LABEL": "Paga",
        "TIP": "Valor da comissão já pago"
      },
      "ADVANCED": {
        "LABEL": "Antecipada",
        "TIP": "Valor da comissão já antecipado"
      }
    },
    "TOTALIZERS": {
      "TOTAL": "Agenciamentos Totais",
      "RECEIVABLE": "Agenciamentos Previstos",
      "AVAILABLE_REDEMPTION": "Agenciamentos Creditados"
    },
    "TOTALIZER_CARD_TOTALS": {
      "TIP": "Agenciamentos Previstos + Agenciamentos Creditados"
    },
    "TOTALIZER_CARD_PREVIEW": {
      "TIP": "Agenciamentos que ainda dependem de liberação,\nmediante pagamento pelo cliente da revendedora."
    },
    "TOTALIZER_CARD_CREDITED": {
      "TIP": "Agenciamentos que o cliente da revendedora\njá efetuou o pagamento."
    }
  },
  "NOT_ALLOWED": {
    "ACCESS_MY": "Acessar MyAccounts"
  },
  "WELLCOME": {
    "COMMAND": "Acessar MyScanSource"
  },
  "GOODBYE": {
    "COMMAND": "Voltar ao MyScanSource"
  },
  "WELCOME": {
    "COMMAND": "Acessar o MyScanSource"
  },
  "COMMISSION": {
    "DETAILS": {
      "VIEW": {
        "INSTALLMENT": {
          "INSTALLMENT": "Número da parcela de pagamento.",
          "STATUS": "Situação da parcela de pagamento.",
          "VALUE": "Valor da comissão bruta referente à parcela, sem a dedução de taxas e descontos.",
          "DUE_DATE": "Data do vencimento para pagamento da parcela.",
          "PAYMENT_DATE": "Data em que o pagamento foi realizado pelo cliente.",
          "NET_VALUE": "Valor da comissão liquida referente à parcela,\ncom os seus respectivos valores de taxas e\n descontos abatidos.",
          "HEADER": {
            "INSTALLMENT": "Parcela",
            "STATUS": "Status",
            "VALUE": "Valor Parcela",
            "DUE_DATE": "Vencimento",
            "PAYMENT_DATE": "Pagamento",
            "NET_VALUE": "Comissão Líquida"
          }
        }
      }
    }
  },
  "REDEMPTIONS": {
    "STATUS": {
      "PAID": "Pago",
      "REFUSED": "Recusado",
      "REQUESTED": "Solicitado",
      "UNDER_ANALYSIS": "Em análise",
      "IN_PROCESS": "Em processamento"
    }
  },
  "SALES_COMMISSION_LIST_ITEM": {
    "INVOICE_NUMBER": "Nota Fiscal / Série",
    "ORDER_NUMBER": "Pedido",
    "CREATED_AT": "Data de Emissão"
  }
}
